import { gql } from '@apollo/client';

const GET_DOWNLOAD_STATUS = gql`
  query GetDownloadStatus($requestId: String!) {
    documentRequestStatus(requestId: $requestId) {
      accountId
      applicationId
      failedDocuments {
        date
        url
      }
      fileName
      processedTz
      requestId
      requesterId
      role
      totalDocuments
    }
  }
`;

const GET_DOWNLOAD_URL = gql`
  query GetDownloadUrl($requestId: String!) {
    documentDownloadUrl(requestId: $requestId)
  }
`;

export { GET_DOWNLOAD_STATUS, GET_DOWNLOAD_URL };
